import application from 'application/application';

import 'select2';

application

	.directive('ngSelect', ['$timeout', $timeout => ({
		restrict: 'A',
		scope: {
			ngModel: '=',
			ngSelectUrl: '='
		},
		link(scope, element, attributes) {

			let

				options = {
					theme: 'bootstrap',
					width: '100%',
					placeholder: attributes.placeholder,
					dropdownParent: ('ngSelectRelativeElement' in attributes) ? $(element).closest(attributes.ngSelectRelativeElement ? attributes.ngSelectRelativeElement : 'body') : ($(element).closest('.modal').length ? $(element).closest('form') : '')
				};

			if (scope.ngSelectUrl)

				options.ajax = {
					delay: 100,
					url: scope.ngSelectUrl,
					data(params) {

						let

							object = {
								paginaAtual: params.page,
								itensPorPagina: 10
							};

						object[attributes.ngSelectParam || 'q'] = params.term;

						return object;

					},
					processResults(data) {

						return {
							results: data.itens.map(item => {

								return {
									id: item.id,
									text: item.palavraChave
								};

							})
						};

					}
				};

			$(element)

				.select2(options)

				.on('select2:select', () => $timeout(() => {

					scope.ngModel = this.value;

					scope.$apply();

				}))

				.on('select2:opening', () => $(window).on('resize.select2', () => $(element).select2('close')))

				// Desatch resize event on close
				.on('select2:closing', () => $(window).off('resize.select2'));

			scope

				.$watch('ngModel', (newValue, oldValue) => {

					const stringify = val => typeof val === 'object' ? JSON.stringify(val) : val;

					if (stringify(newValue) == stringify(oldValue))

						return;

					$timeout(() => {

						element.triggerHandler('change.select2');

						$(element).trigger('change');

					});

				});

		}

	})]);
